var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-wrap"},[_c('div',{staticClass:"setting-item"},[_c('h3',{staticClass:"setting-title"},[_vm._v(_vm._s(_vm.$t('common_196')))]),_c('theme-replacer')],1),_c('div',{staticClass:"setting-item"},[_c('h3',{staticClass:"setting-title"},[_vm._v(_vm._s(_vm.$t('common_197')))]),_c('theme-color-replacer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }